export default (image: string): string => {
  return image ? `url(${image})` : `url(${require(`images/placeholder-image.png`)})`
}